export type { StyledTextProps, StyledTextSlots } from './StyledText';
export { StyledText, styledTextClassName } from './StyledText';
export { useSizeStyles, useStyles, useWeightStyles } from './StyledText.styles';
